import { Product } from '../..';
import {
  privatePensionAvailableProductsFiltersQuery,
  privatePensionAvailableProductsQuery,
} from '../../../../../../../../store/availableProducts/selectors';
import { privatePensionProductsLoadedState } from '../../../../../../../../store/product/atom';

import { PrivatePensionItem } from './ListItem';
import { ListLoadingItem } from './ListLoadingItem';

export const PrivatePensionProduct = () => {
  return (
    <Product
      productsQuery={privatePensionAvailableProductsQuery}
      customFiltersQuery={privatePensionAvailableProductsFiltersQuery}
      ProductItem={PrivatePensionItem}
      ProductItemLoading={ListLoadingItem}
      atomToSetProductsLoaded={privatePensionProductsLoadedState}
    />
  );
};
